export default {
  ticketList: {
    listDesc: "جميع التذاكر التي أرسلتها إلى دعم Excoino مذكورة في هذه الصفحة:",
    submitTicket: "إرسال تذكرة جديدة",
    noMessages: "ليس لديك رسائل",
    id: "المعرف",
    department: "القسم",
    subject: "الموضوع",
    lastUpdate: "آخر تحديث",
    status: "الحالة",
    previousTickets: ""
  },
  singleTicket: {
    closed: "مغلق",
    closeTicket: "إغلاق التذكرة",
    viewMore: "عرض المزيد",
    ticketIsClosed: "هذه التذكرة مغلقة",
    ticketWasClosed: "تم إغلاق التذكرة",
    submitTicketIfHaveQuestion: "إذا كان لديك أي أسئلة، يرجى إرسال تذكرة جديدة",
    submitTicket: "إرسال تذكرة جديدة",
    messagePlaceholder: "الرسالة...",
    doYouClose: "هل أنت متأكد أنك تريد إغلاق التذكرة؟",
    sureClose: "نعم، أغلق التذكرة",
    giveUp: "إلغاء إغلاق التذكرة",
    notAValidFormat: "تنسيق الملف غير صالح.",
    notAValidSize: "يجب أن يكون حجم الملف أقل من 4 ميغابايت."
  },
  createTicket: {
    selectSubject: "يرجى تحديد الموضوع المطلوب لإرسال طلب الدعم:",
    subject: "الموضوع",
    title: "العنوان",
    titleError: "أدخل عنوان التذكرة",
    messagePlaceholder: "وصف مشكلتك...",
    messageError: "أدخل وصف التذكرة",
    attachmentTitle: "إرفاق ملف (اختياري)",
    submit: "إرسال",
    hintsTitle: "للحصول على استجابة أفضل، انتبه إلى ما يلي:",
    supportNumber: "هاتف الدعم:",
    supportEmail: "بريد الدعم الإلكتروني:",
    alerts: {
      alertDesc:
        "يرجى ملاحظة أن Excoino لن تطلب منك أبدًا كلمات المرور الخاصة بك. لا تعطي معلومات محفظتك الخاصة لأي شخص."
    },
    attachment: {
      fileFormats: "تنسيقات الملفات المسموح بها: jpg، jpeg، png",
      fileFormatIsNotCorrect: "تنسيق الملف غير صالح.",
      moreThanMaxSize: " يجب ألا يتجاوز حجم الملف المرفق {count} ميغابايت.",
      lessThanMinSize: "يجب ألا يقل حجم الملف المرفق عن {count} ميغابايت."
    }
  },
  conversation: {
    excoinoSupport: "دعم Excoino"
  }
};
